import { ElementType, JSX, useEffect, useRef } from 'react';

import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useSuperState } from 'hooks';

import 'components/truncated_text/styles/TruncatedText.scss';

type TruncatedTextProps = {
    as?: keyof JSX.IntrinsicElements;
    children: string;
    className?: string;
    maxWidth?: number | string;
};

export const TruncatedText = (props: TruncatedTextProps) => {

    const { as = 'span', children, className, maxWidth } = props;

    const [state, setState] = useSuperState({ isTruncated: false });

    const elementRef = useRef<HTMLElement>(null);

    useEffect(() => {

        const checkTruncation = () => {

            if (elementRef.current) {

                setState({ isTruncated: elementRef.current.scrollWidth > elementRef.current.clientWidth });

            }

        };

        checkTruncation();

        const observer = new ResizeObserver(checkTruncation);

        if (elementRef.current) {

            observer.observe(elementRef.current);

        }

        return () => observer.disconnect();

    }, [children]);

    const Tag = as as ElementType;

    const element = (
        <Tag
            className={`d-block overflow-hidden truncated-text${className ? ` ${className}` : ''}`}
            ref={elementRef as React.Ref<HTMLElement>}
            style={{ maxWidth }}
        >
            {children}
        </Tag>
    );

    return state.isTruncated ? (
        <OverlayTrigger
            overlay={(
                <Tooltip>
                    {children}
                </Tooltip>
            )}
            placement="top"
        >
            {element}
        </OverlayTrigger>
    ) : element;

};
